export enum PlantPeriodType {
  Year,
  Quarter,
  Month,
}
